import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import OpenSettingsCard from '../components/card/OpenSettingsCard';
import { FaUserTie } from "react-icons/fa6";
import { meDetails, switchUserRole } from '../services/UserService';
import PlansCard from '../stripe/PlansCard';
import { useNavigate } from "react-router-dom";
import { Icon } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { blue } from '@mui/material/colors';
export default function AccountMenu(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [settingsCardOpen, setSettingsCardOpen] = React.useState(false);
  const [plansCardOpen, setPlansCardOpen] = React.useState(false);
  const [changeToRole, setChangeToRole] = React.useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const openSettings = () => {
    navigate("/opensettings");
  };

  const openMyProfile = () => {
    navigate('/my-profile');
  };

  const openPlansCard = () => {
    navigate("/plans");
    //setPlansCardOpen(true);
    //return <PlansCard />
  };
  const openInvoiceCard = () => {
    navigate("/invoices");
    //setPlansCardOpen(true);
    //return <PlansCard />
  };
  React.useEffect(() => {
    if (props.additionalUserInfo) {
      if (props.additionalUserInfo.role === "ROLE_EMPLOYEE" || props.additionalUserInfo.role === "ROLE_MANAGER" || props.additionalUserInfo.role === "ROLE_CMANAGER" ||  props.additionalUserInfo.role === "ROLE_FMANAGER" || props.additionalUserInfo.role === "ROLE_SADMIN") {
        setChangeToRole("ROLE_INDIVIDUAL");
      } else {
        if (props.additionalUserInfo.roleBeforeSwitch) {
          setChangeToRole(props.additionalUserInfo.roleBeforeSwitch);
        }
      }
    }

  }, [props.additionalUserInfo]);
  const showProfileIcon = () => {


    if (props.additionalUserInfo !== null && props.additionalUserInfo.firstName) {

      return props.additionalUserInfo.firstName.charAt(0).toUpperCase();

    } else {
      return <FaUserTie />

    }
    return
  }

  const switchUser = () => {
    switchUserRole(props.token, props.additionalUserInfo.email, changeToRole).then((response) => {
      console.log(response);
      if (response) {
        meDetails(props.token, props.setRole, props.setAdditionalUserInfo).then((role) => {
          console.log(role);
          if (role === "ROLE_EMPLOYEE" || role === "ROLE_MANAGER" || role === "ROLE_SADMIN" || role === "ROLE_CMANAGER" || role === "ROLE_FMANAGER") {
            setChangeToRole("ROLE_INDIVIDUAL");
          } else {
            console.log(props.additionalUserInfo.roleBeforeSwitch);
            setChangeToRole(props.additionalUserInfo.roleBeforeSwitch);
          }
        }

      );
      }
    });
    window.location.reload();
  }

  const showRoleText = (roleType) => {
    if (roleType === "ROLE_INDIVIDUAL") {
      return "Personal";
    } else if (roleType === "ROLE_EMPLOYEE") {
      return "Employee";
    } else if (roleType === "ROLE_MANAGER") {
      return "Manager";
    } else if (roleType === "ROLE_CMANAGER") {
      return "Company Manager";
    
    } else if (roleType === "ROLE_FMANAGER") {
      return "Finance Manager";
    
    
    } else if (roleType === "ROLE_ADMIN") {
      return "Admin";
    }
    else if (roleType === "ROLE_SADMIN") {
      return "Super Admin";
    }
  }
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Typography sx={{ minWidth: 100 }}>Contact</Typography>
        <Typography sx={{ minWidth: 100 }}>Profile</Typography>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>{showProfileIcon()}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem >
            <InfoIcon color="" sx={{ color:blue[500] }} /> Current user mode: {showRoleText(props.role)} 
          </MenuItem>
        {changeToRole ?
          <MenuItem onClick={switchUser}>
            <Avatar /> Switch to {showRoleText(changeToRole)}
          </MenuItem> : ''}
        <MenuItem onClick={openMyProfile}>
          <Avatar /> My Profile
        </MenuItem>
        <MenuItem onClick={openSettings}>
          <Avatar /> Settings
        </MenuItem>
        {(props.role === "ROLE_CMANAGER" || props.role === "ROLE_MANAGER" || props.role === "ROLE_SADMIN") &&
        <MenuItem onClick={openPlansCard}>
          <Avatar /> Plans & Billing
        </MenuItem>
        }
        <MenuItem onClick={openInvoiceCard}>
          <Avatar /> Invoices
        </MenuItem>
        
        <Divider />
        <MenuItem onClick={props.signOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Sign out
        </MenuItem>
      </Menu>
     
     
    </React.Fragment>
  );
}
